import { Chip, inputCls } from './ui';
import { daysAgo, todayDateInput } from '../lib/date-input';

const PRESETS = [
  { label: '오늘', days: 1 },
  { label: '7일', days: 7 },
  { label: '30일', days: 30 },
] as const;

/**
 * 목록 기간 필터 — 오늘·7일·30일·전체 바로가기 + 시작·끝 날짜. 양 끝 날짜 포함, 빈 값은 제한 없음.
 * 바꾸면 onChange(시작, 끝) 한 번 — 부모가 페이지를 1로 되돌리는 등 함께 처리한다
 */
export function DateRangeFilter({
  from,
  to,
  onChange,
}: {
  from: string;
  to: string;
  onChange(from: string, to: string): void;
}) {
  const today = todayDateInput();
  return (
    <div className="ml-auto flex items-center gap-1.5 text-xs text-muted-foreground">
      {PRESETS.map((preset) => (
        <Chip
          key={preset.label}
          active={from === daysAgo(preset.days) && to === today}
          onClick={() => onChange(daysAgo(preset.days), today)}
        >
          {preset.label}
        </Chip>
      ))}
      <Chip active={!from && !to} onClick={() => onChange('', '')}>
        전체
      </Chip>
      <input
        type="date"
        aria-label="시작일"
        className={inputCls}
        value={from}
        max={to || undefined}
        onChange={(e) => onChange(e.target.value, to)}
      />
      <span>—</span>
      <input
        type="date"
        aria-label="종료일"
        className={inputCls}
        value={to}
        min={from || undefined}
        onChange={(e) => onChange(from, e.target.value)}
      />
    </div>
  );
}
